
import { mapState } from "vuex";

export default {
  data() {
    return {
      photo: {}
    };
  },
  props: {
    img: {
      type: [String, Object, File],
      required: true,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    getImg() {
      return typeof this.img === "string"
        ? this.img
        : this.getThumbnail(this.img);
    }
  },
  methods: {
    handleChange(e) {
      const photo = e.target.files[0];
      if (photo) {
        if (photo.size > 1000000) {
          this.$nuxt.$emit(
            "show-error-toast",
            "Selected image exceeds max size"
          );
        } else {
          this.$emit("picture-change", photo);
        }
      }
    }
  }
};
